export default __webpack_public_path__ + "static/media/x-one-black.ec8472e0.svg";